import { render, staticRenderFns } from "./Signing.vue?vue&type=template&id=64a5d2d2&scoped=true&"
import script from "./Signing.vue?vue&type=script&lang=js&"
export * from "./Signing.vue?vue&type=script&lang=js&"
import style0 from "./Signing.vue?vue&type=style&index=0&id=64a5d2d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a5d2d2",
  null
  
)

export default component.exports